/** @component */
export { default } from './ActivityIndicator';
